export default function NotesBox({
  personalDetailsNote,
  visaInformationNote,
  australianEducationNote,
}) {
  return (
    <div className="border-[2px] border-black/35 bg-secondary px-5 py-4 bg-[#ffeee0]">
      <p className="font-medium mb-2">Notes made by receptionist:</p>
      <p className="text-[15px] leading-relaxed">
        {personalDetailsNote} <br /> {visaInformationNote} <br /> {australianEducationNote} <br />
      </p>
    </div>
  )
}
